// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3JRXY","header":"PatientQuestionnaire_header__3sE22","info":"PatientQuestionnaire_info__8JuMN"};